import React, { useId } from "react";

/** A labelled <select> for a filter bar — label is visible and programmatically tied. */
interface Props {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
  className?: string;
}

const FilterSelect: React.FC<Props> = ({ label, value, onChange, options, className = "" }) => {
  const id = useId();
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <label htmlFor={id} className="text-xs font-medium uppercase tracking-wide text-gray-300">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`rounded-md border bg-gray-800 px-2.5 py-1.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 ${
          options.length && value !== options[0].value ? "border-cyan-600" : "border-gray-700"
        }`}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterSelect;
